var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../classes/runtime/Runtime';
let GradeDisplay = class GradeDisplay extends React.PureComponent {
    get prefix() {
        if (runtime.solidBrowserRuntime.browserDevice.isSmartphone)
            return null;
        return;
    }
    get color() {
        return '#CCC';
    }
    render() {
        const { app } = this.props;
        if (!app.user.userStore.showGrade)
            return null;
        return (React.createElement("div", { style: { display: 'block', marginTop: 15 } },
            React.createElement("h3", null,
                "Note: ",
                React.createElement("span", { style: { color: app.cycle.cycleGrade.currentGradeColor } }, app.cycle.cycleGrade.currentGradeString))));
    }
};
GradeDisplay = __decorate([
    observer
], GradeDisplay);
export { GradeDisplay };
